import { ForeverRegionCookieKey, SessionRegionCookieKey } from '../../../shared/constants/geoCookies';
import { getCookie } from '../../../shared/utils/helpers/cookie_helper';

export const resolveCookieRegion = () => {
  const sessionRegionId = getCookie(document.cookie, SessionRegionCookieKey);
  const foreverRegionId = getCookie(document.cookie, ForeverRegionCookieKey);

  return Number(sessionRegionId) || Number(foreverRegionId) || null;
};
